var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestoneManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24.492 31.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    transform: "translate(-11.75 -5.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8474",
    "data-name": "Group 8474",
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25118",
    "data-name": "Path 25118",
    d: "M31.421,14.391l4.352-6.528a1.2,1.2,0,0,0-1-1.863H13.2A1.2,1.2,0,0,0,12,7.2V35.968a1.2,1.2,0,1,0,2.4,0V22.782H34.776a1.2,1.2,0,0,0,1-1.863ZM14.4,20.385V8.4H32.536l-3.552,5.329a1.2,1.2,0,0,0,0,1.33l3.552,5.328Z",
    transform: "translate(-12 -6)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25119",
    "data-name": "Path 25119",
    d: "M29.729,12.126a1.2,1.2,0,0,0-1.609.536l-2.852,5.7-1.222-1.222a1.2,1.2,0,1,0-1.7,1.7l2.4,2.4a1.2,1.2,0,0,0,.848.351,1.155,1.155,0,0,0,.192-.016,1.2,1.2,0,0,0,.88-.647l3.6-7.192a1.2,1.2,0,0,0-.536-1.608Z",
    transform: "translate(-16.006 -8.403)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneManagement);
export default __webpack_public_path__ + "static/media/MilestoneManagement.fb8daf3fbd318eebf64db4a5499b82ba.svg";
export { ForwardRef as ReactComponent };